import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import Tailwind CSS
import App from './App';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MessagesPage from './components/MessagesPage';

// Custom PrivateRoute component to handle authentication
const PrivateRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const isAuthenticated = !!localStorage.getItem('userId');
  
  if (!isAuthenticated) {
    // Redirect them to the home page if not authenticated
    return <Navigate to="/" replace />;
  }

  return element;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Main app routes */}
        <Route path="/" element={<App />} />
        <Route path="/fr" element={<App />} />
        <Route path="/it" element={<App />} />
        
        {/* Protected Messages route */}
        <Route 
          path="/messages" 
          element={
            <PrivateRoute element={<MessagesPage />} />
          } 
        />
        
        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);